import { useMemo } from "react";
import { Modal, inputCls, btnPrimary } from "../bits";

export function OppFormModal({ open, mode, onClose, form, setForm, values, busy, onSave }) {
  const supportingOptions = useMemo(() => values.filter((v) => v.name !== form.main_value), [values, form.main_value]);

  const toggleSupport = (name) => {
    const cur = form.supporting_values || [];
    setForm({ ...form, supporting_values: cur.includes(name) ? cur.filter((v) => v !== name) : [...cur, name] });
  };

  return (
    <Modal open={open} onClose={onClose}
      title={mode === "edit" ? "تعديل الفرصة" : "فرصة تطوعية جديدة"} wide testid="opportunity-form-modal">
      <div className="grid sm:grid-cols-2 gap-3">
        <div className="sm:col-span-2">
          <label className="text-xs font-bold text-mutext block mb-1.5">اسم الفرصة *</label>
          <input data-testid="opp-name-input" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} className={inputCls} />
        </div>
        <div className="sm:col-span-2">
          <label className="text-xs font-bold text-mutext block mb-1.5">الوصف</label>
          <textarea data-testid="opp-desc-input" value={form.description} onChange={(e) => setForm({ ...form, description: e.target.value })} className={inputCls} rows={2} />
        </div>
        <div>
          <label className="text-xs font-bold text-mutext block mb-1.5">الموقع</label>
          <input data-testid="opp-location-input" value={form.location} onChange={(e) => setForm({ ...form, location: e.target.value })} className={inputCls} />
        </div>
        <div>
          <label className="text-xs font-bold text-mutext block mb-1.5">الفئة</label>
          <select data-testid="opp-category-select" value={form.category} onChange={(e) => setForm({ ...form, category: e.target.value })} className={inputCls}>
            {["عامة", "بيئة مدرسية", "قيم وأخلاق", "صحة وسلامة", "تعليمية", "بيئية", "وطنية", "مجتمعية"].map((c) => <option key={c}>{c}</option>)}
          </select>
        </div>
        <div>
          <label className="text-xs font-bold text-mutext block mb-1.5">مستوى الفرصة</label>
          <select data-testid="opp-level-select" value={form.level || "عام (28 ر.س/ساعة)"} onChange={(e) => setForm({ ...form, level: e.target.value })} className={inputCls}>
            {["عام (28 ر.س/ساعة)", "ميداني (35 ر.س/ساعة)", "تخصصي (45 ر.س/ساعة)"].map((l) => <option key={l}>{l}</option>)}
          </select>
        </div>
        <div>
          <label className="text-xs font-bold text-mutext block mb-1.5">نوع المتطوع</label>
          <select data-testid="opp-volunteer-type-select" value={form.volunteer_type || "الجميع"} onChange={(e) => setForm({ ...form, volunteer_type: e.target.value })} className={inputCls}>
            {["الجميع", "الطلاب", "المنسوبون"].map((t) => <option key={t}>{t}</option>)}
          </select>
        </div>
        <div>
          <label className="text-xs font-bold text-mutext block mb-1.5">تاريخ البداية</label>
          <input data-testid="opp-start-input" type="date" value={form.start_date} onChange={(e) => setForm({ ...form, start_date: e.target.value })} className={inputCls} dir="ltr" />
        </div>
        <div>
          <label className="text-xs font-bold text-mutext block mb-1.5">تاريخ النهاية</label>
          <input data-testid="opp-end-input" type="date" value={form.end_date} onChange={(e) => setForm({ ...form, end_date: e.target.value })} className={inputCls} dir="ltr" />
        </div>
        <div>
          <label className="text-xs font-bold text-mutext block mb-1.5">عدد المتطوعين في هذه الفرصة (بحد أقصى 50)</label>
          <input data-testid="opp-seats-input" type="number" min="0" max="50" value={form.seats} onChange={(e) => setForm({ ...form, seats: Number(e.target.value) })} className={inputCls} />
        </div>
        <div>
          <label className="text-xs font-bold text-mutext block mb-1.5">الحالة</label>
          <select data-testid="opp-status-select" value={form.status} onChange={(e) => setForm({ ...form, status: e.target.value })} className={inputCls}>
            <option value="planned">مخطط لها</option>
            <option value="open">مفتوحة</option>
            <option value="done">منفذة</option>
            <option value="cancelled">ملغاة</option>
          </select>
        </div>
        <div>
          <label className="text-xs font-bold text-mutext block mb-1.5">عدد الساعات المعتمدة للفرصة (بحد أقصى 50)</label>
          <input data-testid="opp-hours-input" type="number" min="0" max="50" value={form.hours || 0}
            onChange={(e) => setForm({ ...form, hours: Number(e.target.value) })} className={inputCls} />
        </div>
        <div>
          <label className="text-xs font-bold text-mutext block mb-1.5">القيمة الرئيسية *</label>
          <select data-testid="opp-main-value-select" value={form.main_value} onChange={(e) => setForm({ ...form, main_value: e.target.value })} className={inputCls}>
            <option value="">— اختر القيمة —</option>
            {values.map((v) => <option key={v.key} value={v.name}>{v.name}</option>)}
          </select>
        </div>
        <div>
          <label className="text-xs font-bold text-mutext block mb-1.5">القيم المساندة</label>
          <div className="flex flex-wrap gap-1.5" data-testid="opp-supporting-values">
            {supportingOptions.map((v) => (
              <button type="button" key={v.key} data-testid={`opp-support-${v.key}`} onClick={() => toggleSupport(v.name)}
                className={`text-[11px] font-bold rounded-full px-3 py-1.5 border transition-colors ${
                  (form.supporting_values || []).includes(v.name)
                    ? "bg-turq-600 text-white border-turq-600"
                    : "bg-surface text-mutext border-brd hover:border-turq-600"}`}>
                {v.name}
              </button>
            ))}
          </div>
        </div>
        <div className="sm:col-span-2">
          <label className="text-xs font-bold text-mutext block mb-1.5">الأثر المتوقع</label>
          <input data-testid="opp-impact-input" value={form.expected_impact} onChange={(e) => setForm({ ...form, expected_impact: e.target.value })} className={inputCls}
            placeholder="مثال: الالتزام بالنظام والوقت" />
        </div>
        <button data-testid="opp-save-btn" onClick={onSave} disabled={busy} className={`${btnPrimary} sm:col-span-2 justify-center`}>
          {busy ? "جارٍ الحفظ …" : "حفظ الفرصة"}
        </button>
      </div>
    </Modal>
  );
}
